import React from 'react';

const Medal = ({ text="Go Event", color = 'blue' }) => {
	const initials = text.match(/(\b\S)?/g).join("").match(/(^\S|\S$)?/g).join("").toUpperCase()
	return <div className={`medal medal-${color}`}>{initials}</div>;
};

export default Medal;
